import { refreshToken } from "./nimble";
 
 
let token = null;
let refAuthID = null;
let refreshTimer = null;
let urlVersion = null;
 
 
 
export function setToken(newToken, minutesToExpire, newRefAuthID, urlV ,enableRefresh = false) {
    // export function setToken(newToken) {
    token = newToken;
    refAuthID = newRefAuthID;
    urlVersion = urlV
    // scheduleRefresh(minutesToExpire);
    if (enableRefresh && minutesToExpire) {
        scheduleRefresh(minutesToExpire);
    }
};
 
export function getToken() {
    return token;
};
 
function scheduleRefresh(minutesToExpire) {
    if (refreshTimer) clearTimeout(refreshTimer);
 
    const refreshInMs = Math.max((minutesToExpire - 2) * 60 * 1000, 0);
     refreshTimer = setTimeout(async () => {
        const result = await refreshToken(token, urlVersion, refAuthID);
 
        if (result) {
            setToken(result.token, result.minutesToExpire, result.refAuthID ,urlVersion ,true);
        }
    }, refreshInMs);
};